import React, { useEffect, useRef, useState } from 'react'
import './CasinoProvider.scss'
import HeaderTabs from './ProviderTabs/HeaderTabs'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { connectCasinoProvider } from './CasinoProvider.connect'
import { setLoginNew } from '../../store/LoginNew/loginNew.slice'
import { withIonLifeCycle } from '@ionic/react'
import SlotsCasinoPopUp from '../../components/SlotsCasinoPopup'
import { gamesListGap } from '../../store/liveCasino/liveCasino.thunks'

const CasinoProviderGap = ({
  qtechFilter,
  qTechGames,
  auth,
  slotCasinoPopUp,
  actions,
  moreDetailed,
  elementsParams,
}) => {
  console.log('moreDetailed', moreDetailed)
  const [selectedIndex, setSelectedIndex] = useState(
    moreDetailed ? moreDetailed : 'Evolution Gaming'
  )
  const [loading, setLoading] = useState(false)
  const casinoRef = useRef(null)
  const history = useHistory()
  const dispatch = useDispatch()

  

  const getQTechFilter = () => {
    actions
      .requestQtechFilter()
      .catch((e) => console.log('requestQtechFilter error = ', e))
  }

  const getQTechGames = (provider) => {
    setLoading(true)
    actions
      .requestQtechGames(provider)
      .then(() => setLoading(false))
      .catch((e) => console.log('requestQtechGames error = ', e))
  }

  useEffect(() => {
    getQTechFilter()
    getQTechGames(moreDetailed ? moreDetailed : 'EZU')
    setSelectedIndex(moreDetailed ? moreDetailed : 'EZU')
  }, [moreDetailed])

  const onSelectFilter = (data) => {
    setSelectedIndex(data)
    getQTechGames(data)
  }

  const onSelectGame = (data) => {
    if (!data?.game_id) return

    if (auth) {
      history.push(
        `/gap-casino/${data.game_id}/${data?.category}/${data?.provider_name}`
      )
    } else {
      dispatch(setLoginNew(true))
    }
  }

  const gapCasinoList = useSelector(
    (state) => state.liveCasino.gapCasinoList?.data
  )

  useEffect(() => {
    dispatch(
      gamesListGap(
        1,
        '',
        moreDetailed === 'EZU' ? 'Evolution Gaming' : selectedIndex
      )
    )
  }, [moreDetailed])

  const tapData = [
    // 'All',
    'EZUGI',
    'MAC88',

    'JACKTOP',
    'DC',
    'BETCORE',
    'CREED',
    'AWC',
    'KINGMIDAS',
    'BETGAMES',
    'SUNO',
    'CRASH88',
    'SAP',
    'TURBO',
    'JiLi',
    'DRGS',
    'MACAW',
    'MARBLES',
    'SPRIBE',
    'RG',
    'RICH88',
  ]
  return (
    <>
      {slotCasinoPopUp && <SlotsCasinoPopUp />}

      <div ref={casinoRef} className="casino-provider-container">
        <div className="casino-provider-header-list">
          {/* <HeaderTabs
            tabs={qtechFilter}
            selectedIndex={selectedIndex}
            setSelectedIndex={(val) => {
              onSelectFilter(val)
            }}
          /> */}

          <ul role="tablist" classNameName="nav nav-pills" aria-label="Tabs">
            {tapData &&
              tapData.length &&
              tapData.map((item, index) => {
                return (
                  <li className="nav-item" key={item}>
                    <a
                      href="javascript:void(0);"
                      role="tab"
                      className={`nav-link ${
                        selectedIndex === item ? 'selected' : ''
                      }`}
                      aria-controls=""
                      aria-selected="false"
                      id=""
                      onClick={() => {
                        setSelectedIndex(item)
                        dispatch(gamesListGap(1, item))
                      }}
                    >
                      <span></span>
                      <span id={`parentTab-0`}>{item}</span>
                    </a>
                  </li>
                )
              })}
          </ul>
        </div>

        {
          <div className="casino-games-container">
            {gapCasinoList?.length > 0 &&
              gapCasinoList?.map((item) => {
                return (
                  <div
                    className="casino-game-box"
                    key={item?.id}
                    onClick={() => {
                      onSelectGame(item)
                    }}
                  >
                    <div className="casino-icon-box">
                      <img src={item?.url_thumb} alt={item?.game_name} />
                      <div className="casino-name">PLAY NOW</div>
                    </div>
                  </div>
                )
              })}
          </div>
        }

        {loading && (
          <div className="spinner-container">
            <svg
              className="spinner"
              width="65px"
              height="65px"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginTop: '150px' }}
            >
              <circle
                className="path"
                fill="none"
                stroke-width="6"
                stroke-linecap="round"
                cx="33"
                cy="33"
                r="30"
              ></circle>
            </svg>
          </div>
        )}
      </div>
    </>
  )
}

export default withIonLifeCycle(connectCasinoProvider()(CasinoProviderGap))
